import {Dropdown} from 'components/dropdown-menu/Dropdown'
import {SearchBar} from 'components/search-bar/SearchBar'
import {SearchBarProvider} from 'components/search-bar/SearchBarProvider'
import {useMemo, useRef} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {AuthActions} from 'store/modules/authentication/actions'
import {DefaultRoute, Roles, getInitials, hasPermission} from 'utility/utility'
import './app-layout.scss'

export const AppLayout = ({children}) => {
  const notificationRef = useRef(null)
  const userMenuRef = useRef(null)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const {user} = useSelector(store => store.authentication)

  const getActiveClassName = path => {
    const segments = location.pathname.split('/').filter(segment => !!segment)
    return segments.length && `/${segments[0]}` === path ? 'active' : ''
  }

  const onLogout = () => {
    dispatch(AuthActions.logout())
    navigate('/authentication/login', {replace: true, state: null})
  }

  const defaultRoute = useMemo(() => {
    return DefaultRoute()
  }, [])

  return (
    <SearchBarProvider>
      <div className="vw-dashboard">
        <div className="vw-dashboard__sidebar">
          <div className="vw-dashboard__sidebar__logo">
            <img
              src={require('../assets/images/logo-light.png')}
              width="143"
              height="18"
              alt="Video Window"
            />
          </div>
          <nav>
            <ul>
              {hasPermission(Roles.superAdmin) && (
                <li>
                  <Link className={getActiveClassName('/dashboard')} to="/dashboard">
                    <i className="fal fa-tachometer"></i>
                    <span>Dashboard</span>
                  </Link>
                </li>
              )}

              <li>
                <Link className={getActiveClassName(defaultRoute)} to={defaultRoute}>
                  <i className="fal fa-home"></i>
                  <span>Administration</span>
                </Link>
              </li>

              {hasPermission(Roles.superAdmin) && (
                <li>
                  <Link className={getActiveClassName('/super-admin')} to="/super-admin">
                    <i className="fal fa-user"></i>
                    <span>Super Admins</span>
                  </Link>
                </li>
              )}

              {hasPermission(Roles.superAdmin) && (
                <li>
                  <Link className={getActiveClassName('/export')} to="/export">
                    <i className="fal fa-file-csv"></i>
                    <span>Export</span>
                  </Link>
                </li>
              )}
            </ul>
          </nav>
        </div>
        <div className="vw-dashboard__main">
          <div className="vw-dashboard__main__header">
            <SearchBar />
            <nav>
              <ul>
                <li className="vw-alert vw-alert--active">
                  <Dropdown ref={notificationRef} className="dropdown-menu-right" right>
                    <div className="dropdown-item-text dropdown-item-text--alert">
                      {' '}
                      <span>No Notifications Right Now!</span>
                    </div>
                  </Dropdown>
                  <div className="dropdown">
                    <button
                      onClick={() => notificationRef.current.toggle()}
                      className="btn btn-none"
                      type="button"
                      id="alertMenu"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {' '}
                      <i className="fal fa-bell"></i>{' '}
                    </button>
                  </div>
                </li>
                <li className="user">
                  <Dropdown ref={userMenuRef} className="dropdown-menu-right" right>
                    <div className="dropdown-item-text dropdown-item-text">
                      <span>
                        {user?.firstName} {user?.lastName}
                      </span>
                      <span> {user?.email} </span>
                    </div>
                    <button className="dropdown-item" onClick={onLogout}>
                      <i className="fal fa-sign-out mr-2"></i>Logout
                    </button>
                  </Dropdown>
                  <div className="dropdown dropdown-icons">
                    <div
                      onClick={() => userMenuRef.current.toggle()}
                      className="cursor-pointer user__no-img vw-icon-bg vw-icon-bg--d"
                    >
                      { getInitials(`${user?.firstName} ${user?.lastName}`) }
                    </div>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
          {children}
        </div>
      </div>
    </SearchBarProvider>
  )
}
